import {SousMenuItemAggregate} from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import {AutorisationsAggregate} from '../../../../../aggregats/autorisation/autorisations.aggregate';
import {AutorisationAggregate} from '../../../../../aggregats/autorisation/autorisation.aggregate';
import {FonctionLogicielle} from '../../../../fonctions-logicielle-constantes';
import {EparcoursPath} from '../../eparcours-path';

export const personnesSousMenuItem = new SousMenuItemAggregate(
  'Personnes',
  `/${EparcoursPath.root.PERSONNES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Personnes)]),
);

export const entreprisesSousMenuItem = new SousMenuItemAggregate(
  'Entreprises',
  `/${EparcoursPath.root.ENTREPRISES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Entreprises)]),
);

export const formateursSousMenuItem = new SousMenuItemAggregate(
  'Formateurs',
  `/${EparcoursPath.root.FORMATEURS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Formateurs)]),
);
